import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import { Subcategory } from './components/Subcategory';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Subcategories.module.scss';

export const Subcategories: React.FC = () => {
	const { setIDsSelectedCategories, IDsSelectedCategories, searchStringForSubcategories, subcategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const filteredSubcategories = useMemo(() => {
		if (searchStringForSubcategories) {
			const updatedSubcategories = subcategories.map((el) => {
				const filteredSubcategoriesByName = el.subCategories.filter((subCategories) =>
					subCategories.name?.toLowerCase().includes(searchStringForSubcategories.toLowerCase()),
				);
				return { ...el, subCategories: filteredSubcategoriesByName };
			});
			return updatedSubcategories;
		}
		return subcategories;
	}, [searchStringForSubcategories, subcategories]);

	const changeCloseStatus = (categoryID: string) => {
		const copyIDsSelectedCategories = { ...IDsSelectedCategories };
		copyIDsSelectedCategories[categoryID] = !copyIDsSelectedCategories[categoryID];
		setIDsSelectedCategories(copyIDsSelectedCategories, false);
	};

	const deleteCategory = (categoryID: string) => {
		const copyIDsSelectedCategories = { ...IDsSelectedCategories };
		delete copyIDsSelectedCategories[categoryID];
		setIDsSelectedCategories(copyIDsSelectedCategories, true);
	};

	return (
		<div data-test="Subcategories">
			{filteredSubcategories.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedCategories[el.id],
				});

				return (
					<div key={el.id + 'mainDisplaySubcategoryTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.id)}>
									<Text
										translationKey={el.name}
										theme={!IDsSelectedCategories[el.id] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteCategory(el.id)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.subCategories.length ? (
									<Subcategory data={el.subCategories} />
								) : (
									<Text
										className={style.notification}
										translationNameSpace="listing"
										translationKey="noSubcategoriesLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};
